export default __webpack_public_path__ + "static/media/bell.3e883624.png";